var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"plan-vector-map",attrs:{"width":"100%","height":"320px"}},[_c('g',{ref:"base"}),_c('g',{ref:"departamentos"})])}
var staticRenderFns = []

export { render, staticRenderFns }